const initialState = {
  projectCollections: [],
  selectedCollection: null,
  popularPlugins: [],
  popularPluginForm: {},
  totalCollectionPages: 0,
  currentCollectionListPage: 0,
  loginPluginDetail: null,
  loadLoginPluginConfigurationPending: false,
  loadLoginPluginConfigurationError: null,
  installLoginPluginPending: false,
  installLoginPluginError: null,
  loadCollectionForProjectOnBoardPending: false,
  loadCollectionForProjectOnBoardError: null,
  loadOnBoardProjectCollectionDetailPending: false,
  loadOnBoardProjectCollectionDetailError: null,
  loadPopularExtensionPending: false,
  loadPopularExtensionError: null,
  fetchPluginFormPending: false,
  fetchPluginFormError: null,
  changeProjectStatusPending: false,
  changeProjectStatusError: null,
  defaultLoginPluginInstallationPending: false,
  defaultLoginPluginInstallationError: null,
  createCollectionPending: false,
  createCollectionError: null,
  createFieldPending: false,
  createFieldError: null,
  installAdditionalPluginPending: false,
  installAdditionalPluginError: null,
  getXanoSchemaPending: false,
  getXanoSchemaError: null,
  xanoData: [],
  xanoProjectsData: [],
  xanoCollectionNameData: [],
  apiResponseData: {},
  apigetTableData: {},
  xanoProjectslistPending: false,
  xanoProjectslistError: null,
  xanocollectionNamesPending: false,
  xanocollectionNamesError: null,
  apisaveDataCallPending: false,
  apisaveDataCallError: null,
  apicallGetTbalesDataPending: false,
  apicallGetTbalesDataError: null,
  apicallToAddFieldsPending: false,
  apicallToAddFieldsError: null,
  createCollectionWithXanoPending: false,
  createCollectionWithXanoError: null,
};

export default initialState;
